import campaign from './campaign'
import creation from './creation'
import voohCreation from './voohCampaign/voohCreation/voohCreationApi'
import agency from './agency'
import user from './user'
import roles from './roles'
import media from './media'
import report from './report'
import inventory from './inventory'
import companies from './companies'
import emissionPlan from './emissionPlan'
import broadSign from './broadSign'
import bundle from './bundle'
import voohCampaign from './voohCampaign/voohCampaignApi'
import aiDescription from './aiDescription'

export default {
  campaign,
  creation,
  agency,
  user,
  roles,
  media,
  report,
  inventory,
  companies,
  emissionPlan,
  broadSign,
  bundle,
  voohCampaign,
  voohCreation,
  aiDescription,
}
